import React, { useEffect } from 'react';
import { useNavigate } from 'react-router';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import LoginError from './loginError';
import Loader from '../../../../../components/Loader';
import { getRoute, ROUTE_ENUMS } from '../../../../../helpers/routes';
import { PasswordInput, EmailInput } from '../../../../../components/Inputs';
import FormController from '../../../../../components/FormController';
import { useAuth } from '../../../../../hooks/useAuth';
import { CHALLENGE_NAMES } from '../../../../../helpers/enums';

import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

const LoginForm = () => {
	const { t } = useTranslation('login');
	const { authStep, isLoading, signIn } = useAuth();

	const navigate = useNavigate();

	useEffect(() => {
		if (authStep === CHALLENGE_NAMES.CONFIRM_SIGN_IN_WITH_TOTP_CODE) {
			navigate(getRoute(ROUTE_ENUMS.MFA), { replace: true });
		}
	}, [authStep]);

	const handleForgottenPassword = () => {
		navigate(getRoute(ROUTE_ENUMS.FORGOT_PASSWORD), { replace: true });
	};

	if (isLoading) {
		return <Loader />;
	} else {
		return (
			<FormController onSubmit={signIn} options={{ disableValidation: true }}>
				<Stack gap={2}>
					<LoginError />
					<EmailInput id="username" />
					<Stack>
						<PasswordInput id="password" />
						<Stack alignItems="end">
							<Typography
								variant="caption"
								onClick={handleForgottenPassword}
								sx={{
									textDecoration: 'underline',
									cursor: 'pointer',
									color: 'glass.main'
								}}
							>
								{t('buttons.forgottenPassword')}
							</Typography>
						</Stack>
					</Stack>
				</Stack>
			</FormController>
		);
	}
};

LoginForm.propTypes = {
	t: PropTypes.func
};

export default LoginForm;
